// Start the next reporting year from this dossier: new dossier, team and RACI
// carried over, the approved report imported as its N-1 source.
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { api } from "../api/client";
import { invalidate, useMutation } from "../api/resource";
import { useCurrentUser } from "../auth";
import { useDossier } from "../dossier";
import { w } from "../i18n";
import { Dialog } from "./overlay";
import { ErrorState, Notice } from "./ui";

export function RolloverButton() {
  const { dossier } = useDossier();
  const { can } = useCurrentUser();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(String(dossier.reporting_year + 1));
  const [name, setName] = useState(`${dossier.report_type} ${dossier.reporting_year + 1}`);
  const run = useMutation(api.rollover);
  const submit = async () => {
    const result = await run.run(dossier.id, Number(year), name.trim());
    if (result) { invalidate("dossiers"); setOpen(false); navigate(`/dossiers/${result.dossier.id}`); }
  };
  return <>
    <button className="ws-btn" onClick={() => setOpen(true)} disabled={!can("approver")}
      title={can("approver") ? undefined : w("auth.needs", { role: w("role.user.approver") })}>
      <CalendarPlus size={16} />{w("rollover.button")}</button>
    {open && <Dialog title={w("rollover.title")} onClose={() => setOpen(false)} size="sm"
      footer={<><button className="ws-btn" onClick={() => setOpen(false)}>{w("common.cancel")}</button>
        <button className="ws-btn primary" disabled={run.pending || !/^\d{4}$/.test(year) || Number(year) <= dossier.reporting_year}
          onClick={submit}>{w("rollover.create")}</button></>}>
      <Notice tone="info">{w("rollover.body")}</Notice>
      <div className="ws-field" style={{ marginTop: 12 }}><label htmlFor="ro-year">{w("rollover.year")}</label>
        <input id="ro-year" className="ws-input" inputMode="numeric" value={year} onChange={e => setYear(e.target.value)} /></div>
      <div className="ws-field"><label htmlFor="ro-name">{w("rollover.name")}</label>
        <input id="ro-name" className="ws-input" value={name} onChange={e => setName(e.target.value)} /></div>
      {run.error && <ErrorState title={w("rollover.error")} error={run.error} />}
    </Dialog>}
  </>;
}
